/**
 * Canonical base URL for referral links (shared links should point to production).
 * Use NEXT_PUBLIC_APP_URL in production, fallback to growth-sync.com.
 */
export function getReferralBaseUrl(): string {
  if (typeof window !== "undefined") {
    const fromEnv = process.env.NEXT_PUBLIC_APP_URL;
    if (fromEnv) return fromEnv.replace(/\/+$/, "");
    return window.location.origin;
  }
  return process.env.NEXT_PUBLIC_APP_URL || "https://growth-sync.com";
}

/** Build referral URL: https://growth-sync.com/r/<code> */
export function getReferralUrl(referralCode: string): string {
  const base = getReferralBaseUrl();
  return `${base}/r/${encodeURIComponent(referralCode)}`;
}

/** localStorage key for referral code set by /r/[code] before redirect (used on signup). */
export const PENDING_REFERRAL_STORAGE_KEY = "pendingReferralCode";

export const REFERRAL_REWARDS = {
  // XP rewards
  XP_FOR_REFERRER: 100,
  
  // Likes rewards
  LIKES_FOR_REFERRER: 10, // Extra likes for referrer when someone signs up
  LIKES_FOR_NEW_USER: 5,  // Extra likes for new user when they sign up
  
  // Profile boost
  PROFILE_BOOST_FOR_REFERRER: 1, // Profile boost for referrer
  
  // Display strings
  DISPLAY_STRINGS: {
    XP_REWARD: "+100 XP",
    LIKES_FOR_REFERRER: "+10 extra sync requests",
    LIKES_FOR_NEW_USER: "+5 extra sync requests",
    PROFILE_BOOST: "+1 profile boost",
  },
} as const;

/**
 * Helper function to get referral reward display strings
 */
export function getReferralRewardStrings() {
  return REFERRAL_REWARDS.DISPLAY_STRINGS;
}

/**
 * Helper function to get referral reward values
 */
export function getReferralRewardValues() {
  return {
    xp: REFERRAL_REWARDS.XP_FOR_REFERRER,
    likesForReferrer: REFERRAL_REWARDS.LIKES_FOR_REFERRER,
    likesForNewUser: REFERRAL_REWARDS.LIKES_FOR_NEW_USER,
    profileBoost: REFERRAL_REWARDS.PROFILE_BOOST_FOR_REFERRER,
  };
}

